import React from "react";
// import PropTypes from 'prop-types';
import styles from "./styles";
import { useStyles} from "../../hooks";
import { Box, Container, useTheme, useMediaQuery } from "@material-ui/core";
import clsx from 'classnames';

import Header from "../Header";
import FloatingWhatsappButton from "../FloatingWhatsappButton";
import Footer from "../Footer";
import HeaderDrawer from "../HeaderDrawer";
import LoadingIndicator from "../LoadingIndicator";

import { useLoadingIndicatorContext } from "../../hooks/useLoadingIndicatorContext";

const Layout = ({
  children,
  noHeader = false,
  noFooter = false,
  profileHeader = false,
  isHome = false,
  isNotes = false,
  isProduct = false,
  showFloatsButtons = false
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("lg"));
  const { loading } = useLoadingIndicatorContext();
  const classes = useStyles(styles);
  
  return (
    <Container maxWidth={false} style={{ padding: 0, margin: 0 }} className={profileHeader ? classes.panel : classes.web}>
      {!noHeader && (matches ? <Header /> : <HeaderDrawer />)}
      <Box
        //style={{
        //  ...(matches && !noHeader && !profileHeader ? styles.normal : null)
        //}}
        className={clsx({ [classes.normal]: matches && !noHeader && !profileHeader })}
      >
        {children}
      </Box>
      {(isHome || isNotes) && (
        <FloatingWhatsappButton isSocios={isHome} />
      )}
      {(isProduct) && (
        <Box className={classes.floatsButtons}>
          <FloatingWhatsappButton isSocios={true} />
        </Box>
      )}
      
      {!noFooter && <Footer />}
      {loading && <LoadingIndicator fullScreen />}

      {(showFloatsButtons && !isProduct) && (
        <Box className={classes.floatsButtons}>
          <FloatingWhatsappButton isSocios={true} />
        </Box>
      )}
    </Container>
  );
};

// Layout.propTypes = {

// }

export default Layout;
